import { uniq } from 'lodash'
import { Page } from '../../../models/util.model'
import { Execution } from '../models/execution.entity'
import { ExecutionListingKeys } from '../models/execution-listing.model'

/**
 * Parse goods-return page keys
 * @param page - the goods-returns page
 * @returns the page listing keys
 */
export function parseExecutionPageKeys(
  page: Page<Execution>,
): ExecutionListingKeys {
  return page.data.reduce<ExecutionListingKeys>(
    (acc, r) => parseExecutionKeys(r, acc),
    {},
  )
}

/**
 * Parse goods-return keys
 * @param execution - the goods-return
 * @param keys - the keys already loaded
 * @returns the execution listing keys
 */
export function parseExecutionKeys(
  execution: Execution,
  keys: ExecutionListingKeys = {},
): ExecutionListingKeys {
  const activityIds = uniq([
    ...(keys['activityIds'] || []),
    ...(execution.activity._id ? [execution.activity._id] : []),
  ])

  return {
    activityIds,
  }
}
